import { render, staticRenderFns } from "./CopyLinkedTextBehaviorEditor.vue?vue&type=template&id=4f40d968&scoped=true&"
import script from "./CopyLinkedTextBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./CopyLinkedTextBehaviorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CopyLinkedTextBehaviorEditor.vue?vue&type=style&index=0&id=4f40d968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f40d968",
  null
  
)

export default component.exports